import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faTimesCircle } from '@fortawesome/pro-solid-svg-icons'

import { SidebarModal, Text } from '@domain-group/suit-theme'

import type { UseArtworkPayload } from '@hooks/useArtwork'
import type { ArtworkReviewModel } from '@models/types'

import ArtworkReview from './ArtworkReview'

type RenderTitleParams = {
  allArtworkReviewsApproved: boolean,
  filteredArtworkReviews: ArtworkReviewModel[],
}

const renderTitle = (params: RenderTitleParams) => {
  const { allArtworkReviewsApproved, filteredArtworkReviews } = params

  const string = `${filteredArtworkReviews.length} ${filteredArtworkReviews.length === 1 ? 'Review' : 'Reviews'}`

  return (
    <Text color={allArtworkReviewsApproved ? 'green' : 'red'}>
      <FontAwesomeIcon icon={allArtworkReviewsApproved ? faCheckCircle : faTimesCircle} /> {string}
    </Text>
  )
}

interface ReviewsProps {
  artworkPayload: UseArtworkPayload,
}

const Reviews = (props: ReviewsProps) => {
  const {
    artworkPayload: {
      allArtworkReviewsApproved,
      filteredArtworkReviews,
    },
  } = props

  return (
    <SidebarModal.ExpandableSection
      label="Artwork Reviews"
      title={renderTitle({ allArtworkReviewsApproved, filteredArtworkReviews })}
      style={{ marginTop: 16 }}
    >
      {filteredArtworkReviews.map(artworkReview => (
        <ArtworkReview
          artworkReview={artworkReview}
          key={artworkReview.id}
        />
      ))}
    </SidebarModal.ExpandableSection>
  )
}

export default Reviews
